module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1025-f4364d91da120f04406728f89d07d872.png";